import React, { useState } from "react";
import styles from "./FilterList.module.css";

function FilterList({ filters, selectedValue, onSelect, title }) {
    const [isOpen, setIsOpen] = useState(false);

    if (!filters || filters.length === 0) return null;

    return (
        <div className={styles.filterGroup}>
            <div className={styles.filterHeader} onClick={() => setIsOpen(!isOpen)}>
                <h4>{title}</h4>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <ul className={styles.filterOptions}>
                    <li 
                        onClick={() => { onSelect(null); setIsOpen(false); }} 
                        className={!selectedValue ? styles.active : styles.option}
                    >
                        Усі {title}
                    </li>
                    {filters.map((f, i) => (
                        <li 
                            key={i} 
                            onClick={() => { onSelect(f.value); setIsOpen(false); }} 
                            className={selectedValue === f.value ? styles.active : styles.option}
                        >
                            {f.value}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default FilterList;
